module.exports = __webpack_public_path__ + "static/media/Regulamento_0202409318_Concurso.30161b8e.pdf";